import React from 'react'
import {DIFFERENCES} from "../../../../../assets/images/landing";

const data = [
  {
    title: 'Easy Booking and 24 Hour Turnaround',
    description: 'Schedule your shoot in minutes and get your photos, videos and interactive tours next day.',
    icon: DIFFERENCES.ReceiptIcon
  },
  {
    title: 'Photographers Who Know Real Estate',
    description: 'Work with experienced local professionals who understand how to capture homes for today’s market.',
    icon: DIFFERENCES.PhotoIcon
  },
  {
    title: 'Media Designed to Sell Homes Faster',
    description: 'Real estate photography designed to attract more buyers and sell homes faster.',
    icon: DIFFERENCES.BadgeIcon
  }
]

export const Difference = ({noTopBorder}) => {
  return <div className={`differences-wrapper ${noTopBorder ? '' : 'top-border'}`}>
    <div className="lead-page-title">Why Do Agents Choose Us?</div>
    <div className="lead-page-wrapper-inner">
      <div className="differences-wrapper-list">
        {data.map((item, i) => (<div className="differences-wrapper-list-item" key={`difference-${i}`}>
          <div className="differences-wrapper-list-item-icon-and-title">
            <img className="differences-wrapper-list-item-icon" src={item.icon} />
            <div className="differences-wrapper-list-item-title">{item.title}</div>
          </div>
          <div className="differences-wrapper-list-item-description">
            {item.description}
          </div>
        </div>))}
      </div>
    </div>
  </div>
}